import { useState } from "react";
import axios from "axios";
import api from "@/store/api";
import { getData } from "@/lib/utils";
import { useDispatch } from "react-redux";
import { getMyCompany } from "@/store/authSlice";
import { useTranslate } from "@/locales";
import { useLocale } from "@/middleware";

const useRegisterCompany = () => {
  const { locale } = useLocale();
  const { t } = useTranslate(locale);

  const [isLoading, setIsLoading] = useState(false);
  const [isSaveLoading, setIsSaveLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const dispatch = useDispatch();

  const updateCompany = async (formData: FormData, id?: string) => {
    setIsSaveLoading(true);
    setError(null);

    try {
      let Token = getData("tokens")?.accessToken;
      const response = await api.put(`/web/companies/${id}`, formData, {
        headers: {
          Authorization: `Bearer ${Token}`,
          "Content-Type": "multipart/form-data",
        },
      });
      setIsSaveLoading(false);
      dispatch(getMyCompany(response.data.data));
      return response.data;
    } catch (err) {
      setIsSaveLoading(false);
      if (axios.isAxiosError(err)) {
        setError(
          err.response?.data?.message ||
            t("alerts.error.companyRegistrationError")
        );
         
      } else {
        setError(t("alerts.error.unexpectedError"));
      }
      throw err;
    }
  };
  const registerCompany = async (formData: FormData) => {
    setIsSaveLoading(true);
    setError(null);

    try {
      let Token = getData("tokens")?.accessToken;
      const response = await api.post("/web/companies/upsert", formData, {
        headers: {
          Authorization: `Bearer ${Token}`,
          "Content-Type": "multipart/form-data",
        },
      });
      setIsSaveLoading(false);
      dispatch(getMyCompany(response.data.data));
      return response.data;
    } catch (err) {
      setIsSaveLoading(false);
      if (axios.isAxiosError(err)) {
        setError(
          err.response?.data?.message ||
            t("alerts.error.companyRegistrationError")
        );
         
      } else {
        setError(t("alerts.error.unexpectedError"));
      }
      throw err;
    }
  };
  const getCompanyMine = async () => {
    try {
      let Token = getData("tokens")?.accessToken;
      const response = await api.get("/web/companies/get/my", {
        headers: {
          Authorization: `Bearer ${Token}`,
        },
      });
      setIsLoading(false);
      if (response.data.data) {
        dispatch(getMyCompany(response.data.data));
      } else {
        dispatch(getMyCompany(null));
      }
      return response.data;
    } catch (err) {
      setIsLoading(false);
      if (axios.isAxiosError(err)) {
        setError(
          err.response?.data?.message ||
            t("alerts.error.companyRegistrationError")
        );
         
      } else {
        setError(t("alerts.error.unexpectedError"));
      }
      throw err;
    }
  };
  const getCompany = async (id: string) => {
    try {
      const response = await api.get("/web/companies/get", { params: { id } }); // Adjust the endpoint as needed
      setIsLoading(false);
      return response.data; // Adjust this based on your API response
    } catch (err) {
      setIsLoading(false);
      if (axios.isAxiosError(err)) {
        setError(
          err.response?.data?.message ||
            t("alerts.error.companyRegistrationError")
        );
      } else {
        setError(t("alerts.error.unexpectedError"));
      }
      throw err;
    }
  };
  return {
    registerCompany,
    getCompanyMine,
    getCompany,
    isSaveLoading,
    isLoading,
    updateCompany,
    error,
  };
};

export default useRegisterCompany;
